<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="sign__page">
          <div class="form">
            <ul class="form__ul">
              <li class="form__li m20">
                <div class="form__ttl">비밀번호</div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="password" placeholder="현재 비밀번호 입력" v-model="params.currentUserPWD" maxlength="15">
                    </label>
                    <div class="hint on" v-show="$v.params.currentUserPWD.$error">{{ valid.msg.currentUserPWD }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">변경할 비밀번호</div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="password" placeholder="변경할 비밀번호 입력" v-model="params.newUserPWD" maxlength="15">
                    </label>
                    <div class="hint on" v-show="$v.params.newUserPWD.$error">{{ valid.msg.newUserPWD }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li">
                <div class="form__ttl">비밀번호 확인</div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="password" placeholder="비밀번호 확인" v-model="params.confirmPassword" maxlength="15">
                    </label>
                    <div class="hint on" v-show="$v.params.confirmPassword.$error">{{ valid.msg.confirmPassword }}</div> <!-- on -->
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm" :class="{'on':isPossibleSave}" @click="fnSave">변경하기</button> <!--활성화: on-->
      </div>
    </div>
  </main>
</template>
<script>
import {required} from 'vuelidate/lib/validators'
export default {
  data: function () {
    return {
      valid: {
        msg: {
          currentUserPWD: '필수항목 입니다.',
          newUserPWD: '',
          confirmPassword: '필수항목 입니다.'
        }
      },
      params: {
        currentUserPWD: '',
        newUserPWD: '',
        confirmPassword: ''
      }
    }
  },
  validations: {
    params: {
      currentUserPWD: {
        required
      },
      newUserPWD: {
        test: function(val) {
          if (!required(val)) {
            this.valid.msg.newUserPWD = '필수항목 입니다.'
            return false
          }
          if (!this.$Util.isPasswordValid(val)) {
            this.valid.msg.newUserPWD = '영문자, 숫자 혼합 8~15자 이내로 입력해주세요.'
            return false
          }
          return true
        }
      },
      confirmPassword: {
        required,
        equal(val, form) {
          if (val !== form.newUserPWD) {
            this.valid.msg.confirmPassword = '위의 비밀번호와 동일하게 입력해주세요.'
            return false
          }
          return true
        }
      }
    }
  },
  computed: {
    isPossibleSave : function () {
      if((this.params.currentUserPWD != '' && !this.$v.params.currentUserPWD.$error) &&
        (this.params.newUserPWD != '' && !this.$v.params.newUserPWD.$error) &&
        (this.params.confirmPassword != '' && !this.$v.params.confirmPassword.$error)) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    fnSave: function() {
      if (!this.$Util.isValid(this.$v, this.$el)) return false

      const params = {}
      params.beforeUserPWD = this.params.currentUserPWD
      params.userPWD = this.params.newUserPWD
      this.$AccountSvc.modifyUserPWD(params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            const _this = this
            this.$Util.modalAlert({message: '변경 되었습니다.'}, function () {
              setTimeout(function () {
                _this.$Util.refreshUserData(function () {
                  _this.$router.go(-1)
                })
              }, 200)
            })
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    }
  }
}
</script>
